/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../Store';

const self = (state: RootState) => state.publicForm;

export const getProject = createSelector(self, (state) => state.project);
export const getProjectData = createSelector(getProject, (state) => state.data);
export const getCurrency = createSelector(self, (state) => state.currency);
export const getCurrencyData = createSelector(getCurrency, (state) => state.data);
